import render from './render'

export default {
  name: 'Format',

  props: {
    value: {
      type: Object,
      default: undefined
    }
  },

  render
}
